import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, i18nextConfig, LANGUAGE_CONFIGS, } from "./config";
let i18nextInstance = null;
let initializationPromise = null;
export async function initializeI18n() {
    if (i18nextInstance) {
        return i18nextInstance;
    }
    if (initializationPromise) {
        return initializationPromise;
    }
    initializationPromise = (async () => {
        try {
            await i18next.use(LanguageDetector).init({
                ...i18nextConfig,
                detection: {
                    order: ["localStorage", "navigator"],
                    caches: ["localStorage"],
                },
            });
            i18nextInstance = i18next;
            return i18nextInstance;
        }
        catch (error) {
            console.error("Failed to initialize i18next:", error);
            throw error;
        }
    })();
    return initializationPromise;
}
export async function ensureI18nInitialized() {
    if (!i18nextInstance) {
        await initializeI18n();
    }
    return i18nextInstance;
}
export async function changeLanguage(language) {
    const instance = await ensureI18nInitialized();
    if (!SUPPORTED_LANGUAGES.includes(language)) {
        console.warn(`Language "${language}" is not supported. Falling back to ${DEFAULT_LANGUAGE}`);
        await instance.changeLanguage(DEFAULT_LANGUAGE);
        return;
    }
    await instance.changeLanguage(language);
}
export function getCurrentLanguage() {
    if (!i18nextInstance) {
        return DEFAULT_LANGUAGE;
    }
    return i18nextInstance.language || DEFAULT_LANGUAGE;
}
export function getSupportedLanguages() {
    return [...SUPPORTED_LANGUAGES];
}
export function getLanguageConfigs() {
    return [...LANGUAGE_CONFIGS];
}
export async function getTranslationFunction(namespace) {
    const instance = await ensureI18nInitialized();
    return (key, defaultValue, options) => {
        return instance.t(key, { defaultValue, ns: namespace, ...options });
    };
}
export async function getTranslation(key, options) {
    const instance = await ensureI18nInitialized();
    return instance.t(key, {
        defaultValue: options?.defaultValue,
        lng: options?.lng,
        ns: options?.ns,
        ...options?.interpolation,
    });
}
export { SUPPORTED_LANGUAGES, SUPPORTED_NAMESPACES, DEFAULT_LANGUAGE, LANGUAGE_CONFIGS, i18nextConfig, getI18nextConfig, mergeI18nextConfig, } from "./config";
export { validateStrings, validateStringsOrThrow, getValidationSummary, } from "./validation";
